import { noop } from 'lodash-es'

import envRaw from '../utils/env-raw'
import debugRaw from '../utils/debug-raw'

debugRaw({
  decorateMath,
  decorateArray,
  decorateTimeout,
  decorateInterval
})

if (envRaw.devMode) {
  decorateMath()
  decorateArray()
  decorateTimeout()
  decorateInterval()
}

function decorateMath() {
  const round = Math.round
  const floor = Math.floor
  const ceil = Math.ceil

  Math.round = function(arg) {
    return round(arg)
  }

  Math.floor = function(arg) {
    return floor(arg)
  }

  Math.ceil = function(arg) {
    return ceil(arg)
  }
}

function decorateArray() {
  const splice = Array.prototype.splice

  Array.prototype.splice = function() {
    return splice.apply(this, arguments)
  }
}

function decorateTimeout() {
  const minId = setTimeout(noop, 0)
  clearTimeout(minId)

  const ids = []
  const origSet = setTimeout
  const origClear = clearTimeout

  window.setTimeout = set
  window.clearTimeout = clear

  function set() {
    const id = origSet(...arguments)
    ids.push(id)
    return id
  }

  function clear() {
    return origClear(...arguments)
  }
}

function decorateInterval() {
  const minId = setInterval(noop, 0)
  clearInterval(minId)

  const ids = []
  const origSet = setInterval
  const origClear = clearInterval

  window.setInterval = set
  window.clearInterval = clear

  function set() {
    const id = origSet(...arguments)
    ids.push(id)
    return id
  }

  function clear() {
    return origClear(...arguments)
  }
}
